@use 'common' as *;

.chip {
  height: 24px; // same as tag chip
  border-radius: 24px;
  overflow: hidden;
  color: var(--dixa-typography-color-primary);
  font-size: var(--dixa-typography-size-200);
  line-height: var(--dixa-typography-line-height-400);
  @include border-100();
}

.chipLabel {
  background-color: var(--dixa-color-neutral-100);
  padding: 0 var(--dixa-size-spacer-200) 0 var(--dixa-size-spacer-250);
  font-weight: var(--dixa-typography-weight-semibold);
  white-space: nowrap;
  @include border-left-100();
}

.chipValueContainer {
  padding: 0 var(--dixa-size-spacer-250) 0 var(--dixa-size-spacer-200);
}

.disabled {
  opacity: var(--dixa-effect-opacity-500);
}
